module.exports = __webpack_public_path__ + "public/img/campaign/2024/thermometer.png";